<div class="custom-input-container" [ngClass]="[size, error ? 'error' : '']">

  @if (label) {
    <label [for]="inputId" class="input-label">{{ label }}</label>
  }

  <!-- Input with Left Icon -->
  @if (icon && iconPosition === 'left') {
    <p-iconfield iconPosition="left">
      <p-inputicon [styleClass]="'pi pi-' + icon"></p-inputicon>
      <input
        #inputRef
        pInputText
        [placeholder]="placeholder"
        [value]="value"
        (input)="onInput($event)"
        (blur)="onBlur()"
        (focus)="onFocus()"
        (keydown)="onKeyDown($event)"
        [attr.disabled]="disabled ? true : null"
        class="custom-input"
        [id]="inputId"
      />
    </p-iconfield>
  }

  <!-- Input with Right Icon -->
  @if (icon && iconPosition === 'right') {
    <p-iconfield iconPosition="right">
      <input
        #inputRef
        pInputText
        [placeholder]="placeholder"
        [value]="value"
        (input)="onInput($event)"
        (blur)="onBlur()"
        (focus)="onFocus()"
        (keydown)="onKeyDown($event)"
        [attr.disabled]="disabled ? true : null"
        class="custom-input"
        [id]="inputId"
      />
      <p-inputicon [styleClass]="'pi pi-' + icon"></p-inputicon>
    </p-iconfield>
  }

  <!-- Input without Icon -->
  @if (!icon) {
    <p-iconfield>
      <input
        #inputRef
        pInputText
        [placeholder]="placeholder"
        [value]="value"
        (input)="onInput($event)"
        (blur)="onBlur()"
        (focus)="onFocus()"
        (keydown)="onKeyDown($event)"
        [attr.disabled]="disabled ? true : null"
        class="custom-input custom-input-witout-icon"
        [id]="inputId"
      />
      <ng-container *ngTemplateOutlet="suffix"></ng-container>
    </p-iconfield>
  }

  <!-- Error Message -->
  @if (error) {
    <div class="error-message">{{ errorMessage }}</div>
  }

  <!-- Helper Text -->
  @if (helperText) {
    <div class="helper-text">{{ helperText }}</div>
  }

</div>